import { Box, Container } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";
import CustomText from "../../customComponents/customText";
import { translation } from "../../assets/translation";
import {
  contactUrl,
  handleUrl,
  language,
  signupurl,
} from "../../assets/function";
import { Colors } from "../../assets/colors";
import CustomButton from "../../customComponents/customButton";
import CustomImage from "../../customComponents/customImage";
import CheckImg from "../../assets/images/checkIcon.svg";
import { motion } from "framer-motion";
function Subscription() {
  let staticText = translation[language];
  let customImageWidth = {
    xs: 8,    // Smaller size for mobile
    sm: 9,    // Medium size for tablets
    md: 6,    // Original size for desktop
    lg: 4,    // Original size for desktop
    xl: 3,    // Original size for desktop
  };
  // Define CardBox component to accept children properly
  const CardBox = ({ children, style }) => <Box sx={style}>{children}</Box>;

  const handleNavigateOtherClick = (event, url) => {
    handleUrl(url, event);
  };
  const CardFeatures = (featureArr) => (
    <Box>
      {featureArr.map((item, index) => (
        <Box
          key={item}
          sx={{ ...styles.itemBox, marginTop: index === 0 ? 4 : 1 }}
        >
          <CustomImage
            filename={CheckImg}
            width={customImageWidth}
            height={customImageWidth}
            sx={{
              ...styles.image,
              width: customImageWidth,
              height: customImageWidth
            }}
          />
          <CustomText
            desc={item}
            fontFamily="Inter"
            colorvalue={Colors.footerTxtColorSub}
            style={{
              ...styles.andaihubTxt,
              marginLeft: {
                xs: 2,    // 8px on mobile
                sm: 1.5,  // 12px on tablet
                md: 2,    // 16px on desktop
              },
              marginTop: {
                xs: 0.25, // 2px on mobile
                sm: 0.35, // 3px on tablet
                md: 0.5,  // 4px on desktop
              },
              fontSize: {
                xs: '0.9rem',  // 14px on mobile
                sm: '1rem',      // 16px on tablet
                md: '1.125rem',  // 18px on desktop
                lg: '1.25rem'    // 20px on large screens
              }


            }}
            h5
            fontWeight={400}
          />
        </Box>
      ))}
    </Box>
  );

  // CardBox1 returns valid JSX content (here, just an empty fragment)
  const CardSubBox = (
    btnBgColor,
    pl,
    pr,
    headText,
    price,
    btnText,
    featureArr,
    btnUrl
  ) => (
    <Box
      sx={{ ...styles.cardSubBoxStyle }}
      onClick={(event) => {
        handleNavigateOtherClick(event, btnUrl);
      }}
    >
      <CustomText
        desc={headText}
        fontFamily="Inter"
        colorvalue={Colors.cardTextColor}
        style={{ ...styles.andaihubTxt, marginTop: 2.5 }}
        h3
        fontWeight={400}
      />
      <CustomText
        desc={
          price === staticText.custom
            ? price
            : `${staticText.inrText} ${price}/${staticText.moText}`
        }
        fontFamily="Epilogue"
        colorvalue={Colors.andaihubTxt}
        style={{
          ...styles.andaihubTxt,
          marginTop: 1,
          marginBottom: 0,
        }}
        {...(headText === staticText.startMsme
          ? { title6: true }
          : { h2: true })}
        fontWeight={400}
      />
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <CustomButton
          style={{
            ...styles.btnStyle,
            backgroundColor: btnBgColor,
            width: {
              xs: '320px',  // Wider on mobile
              sm: '300px',  // Slightly narrower on tablet
              md: '200px',  // Original width on desktop
              lg: '200px',  // Slightly wider for large screens
              xl: '200px'   // Widest for extra large screens
            },
          }}
          body={
            <Box>
              <CustomText
                desc={btnText}
                fontFamily="Epilogue"
                colorvalue={Colors.white}
                style={styles.btnTextStyle}
                h4
                fontWeight={400}
              />
            </Box>
          }
        />
      </Box>
      {CardFeatures(featureArr)}
    </Box>
  );

  return (
    <Box sx={styles.container}>
      <Container maxWidth="xl" sx={styles.containerStyle}>
        <motion.div
          initial={{ opacity: 0, y: 100 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }} // Delayed start for staggered effect
        >
          <Box sx={styles.cardAnimation}>
            <CardBox style={styles.mainCardStyle}>
              {CardSubBox(
                Colors.menuListBgColor,
                2,
                2,
                staticText.freeMonths,
                "800",
                staticText.signUpToday,
                staticText.freeDetail,
                signupurl
              )}
            </CardBox>
          </Box>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 100 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }} // Delayed start for staggered effect
        >
          <Box sx={styles.cardAnimation}>
            <CardBox style={styles.mainCardStyleOne}>
              {CardSubBox(
                Colors.red,
                5,
                5,
                staticText.startMsme,
                "8000",
                staticText.signUpToday,
                staticText.startUpDetail,
                signupurl
              )}
            </CardBox>
          </Box>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 100 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }} // Delayed start for staggered effect
        >
          <Box sx={styles.cardAnimation}>
            <CardBox style={styles.mainCardStyle}>
              {CardSubBox(
                Colors.menuListBgColor,
                5,
                5,
                staticText.enterPrise,
                staticText.custom,
                staticText.contactUs,
                staticText.enterPriseDetail,
                contactUrl
              )}
            </CardBox>
          </Box>
        </motion.div>
      </Container>
    </Box>
  );
}

const styles = {
  mainCardStyle: {

    
    
   
    borderRadius: 4,
    borderStyle: "solid",
    borderWidth: 2,
    borderColor: Colors.bgBorderColor,

    justifyContent: "center",

    marginLeft: {
      xs: 1,    // 8px on mobile
      sm: 2,    // 16px on tablet
      md: 3.8,  // ~30px on desktop
    },
    marginRight: {
      xs: 1,    // 8px on mobile
      sm: 2,    // 16px on tablet
      md: 3.8,  // ~30px on desktop
    },
    paddingTop: {
      xs: 1,    // 8px on mobile
      sm: 1.5,  // 12px on tablet
      md: 2,    // 16px on desktop
    },
    paddingBottom: {
      xs: 2,    // 16px on mobile
      sm: 2.5,  // 20px on tablet
      md: 3,    // 24px on desktop
    },
    paddingLeft: {
      xs: 2,    // 16px on mobile
      sm: 3,    // 24px on tablet
      md: 4,    // 32px on desktop
      lg: 5,    // 40px on large screens
      xl: 6     // 48px on extra large screens
    },
    paddingRight: {
      xs: 2,    // 16px on mobile
      sm: 3,    // 24px on tablet
      md: 4,    // 32px on desktop
      lg: 5,    // 40px on large screens
      xl: 6     // 48px on extra large screens
    },
    
  },
  mainCardStyleOne: {
    borderRadius: 4,
  
    borderStyle: "solid",
    borderWidth: 0,
    borderColor: Colors.cardBgColor,
    backgroundColor: Colors.cardBgColor,
    justifyContent: "center",
    paddingTop: {
      xs: 2,    // 16px on mobile
      sm: 3,    // 24px on tablet
      md: 4,    // 32px on desktop
    },
    paddingBottom: {
      xs: 2,    // 16px on mobile
      sm: 3,    // 24px on tablet
      md: 4,    // 32px on desktop
    },
    paddingLeft: {
      xs: 2,    // 16px on mobile
      sm: 3,    // 24px on tablet
      md: 4,    // 32px on desktop
    },
    paddingRight: {
      xs: 2,    // 16px on mobile
      sm: 3,    // 24px on tablet
      md: 4,    // 32px on desktop
    },
  },
  andaihubTxt: {
    textAlign: "center",
  },
  itemBox: {
    display: "flex",
    marginTop: 1,
    alignItems: "center",
    alignContent: "center",
  },
  btnTextStyle: {
    textTransform: "none",
    fontSize: {
      xs: '0.875rem',  // 14px on mobile
      sm: '1rem',      // 16px on tablet
      md: '1rem',  // 18px on desktop
      lg: '1.25rem' ,   // 20px on large screens
       xl : '0.9rem'
    }
  },
  containerStyle: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: {
      xs: 'column',
      md: 'row'
    },
    gap: {
      xs: '1rem',
      md: '0.2rem'
    },
    
  },
  container: {
    display: "flex",
    alignItems: "center",
    justifyItems: "center",
    justifyContent: "center",
    paddingTop: {
      xs: 6,      // 48px on mobile
      sm: 8,      // 64px on tablet
      md: 10,     // 80px on small desktop
      lg: 12,     // 96px on large desktop
    },
  },
  btnStyle: {
    marginTop: {
      xs: 1,    // 8px on mobile
      sm: 1.25, // 10px on tablet
      md: 1.5,  // 12px on desktop
      lg: 2,    // 16px on large screens
    },
    borderRadius: 1,
    paddingTop: {
      xs: 1,    // 8px on mobile
      sm: 1, // 10px on tablet
      md: 1,  // 12px on desktop
      lg: 1,    // 16px on large screens
    },
    paddingBottom: {
      xs: 1,    // 8px on mobile
      sm: 1, // 10px on tablet
      md: 1,  // 12px on desktop
      lg: 1,    // 16px on large screens
    },
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "center",
    justifyItems: "center",
    backgroundColor: Colors.red,
    display: "flex",
  },
  cardSubBoxStyle: {
    justifyContent: "center",
    alignItems: "center",
  
  },
  cardAnimation: {
    transform: "translateY(20px)",
    animation: "moveUp 0.6s ease forwards",
    "@keyframes moveUp": {
      "0%": {
        opacity: 0,
        transform: "translateY(20px)",
      },
      "100%": {
        opacity: 1,
        transform: "translateY(0)",
      },
    },
  },
};

// PropTypes validation for CardBox component
Subscription.propTypes = {
  children: PropTypes.node.isRequired, // Validate that children is a valid React node
  style: PropTypes.node.isRequired, // Validate that children is a valid React node
};

export default Subscription;
